import axios from "axios"

const verifyOTP = async (otp: { email: string; otp: string }) => {
    try {
        const { data } = await axios.post(
            process.env.NEXT_PUBLIC_API_URL + "users/verify-otp",
            otp
        )

        return data
    } catch (error: any) {
        return error.response.data
    }
}

export default verifyOTP
